export enum Source {
	COACH = "COACH",
	CLAIMS = "CLAIMS",
	QHIN = "QHIN",
	DEVICE = "DEVICE",
	PARTICIPANT = "PARTICIPANT",
}
